"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeWrapped = exports.measureWrapped = exports.write = exports.drawBackground = exports.getSprite = exports.waterScale = exports.fireScale = exports.healthScale = exports.riftScale = exports.rainbowScalePalette = exports.rainbowScale = void 0;
var chroma_js_1 = __importDefault(require("chroma-js"));
var mathUtils_1 = require("../../../lib/mathUtils");
var common_sidecar_1 = require("../../../main/common-sidecar");
var sprites_sidecar_1 = require("../../../sprites/sprites-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueGlyphs_sidecar_1 = require("../targeting/rogueGlyphs-sidecar");
var rogueHotkeys_sidecar_1 = require("./rogueHotkeys-sidecar");
var rogueMouseAreas_sidecar_1 = require("./rogueMouseAreas-sidecar");
var fontMap = {
    _default: sprites_sidecar_1.sprites.monofont64,
    A: sprites_sidecar_1.sprites.monofont00,
    B: sprites_sidecar_1.sprites.monofont01,
    C: sprites_sidecar_1.sprites.monofont02,
    D: sprites_sidecar_1.sprites.monofont03,
    E: sprites_sidecar_1.sprites.monofont04,
    F: sprites_sidecar_1.sprites.monofont05,
    G: sprites_sidecar_1.sprites.monofont06,
    H: sprites_sidecar_1.sprites.monofont07,
    I: sprites_sidecar_1.sprites.monofont20,
    J: sprites_sidecar_1.sprites.monofont21,
    K: sprites_sidecar_1.sprites.monofont22,
    L: sprites_sidecar_1.sprites.monofont23,
    M: sprites_sidecar_1.sprites.monofont24,
    N: sprites_sidecar_1.sprites.monofont25,
    O: sprites_sidecar_1.sprites.monofont26,
    P: sprites_sidecar_1.sprites.monofont27,
    Q: sprites_sidecar_1.sprites.monofont40,
    R: sprites_sidecar_1.sprites.monofont41,
    S: sprites_sidecar_1.sprites.monofont42,
    T: sprites_sidecar_1.sprites.monofont43,
    U: sprites_sidecar_1.sprites.monofont44,
    V: sprites_sidecar_1.sprites.monofont45,
    W: sprites_sidecar_1.sprites.monofont46,
    X: sprites_sidecar_1.sprites.monofont47,
    Y: sprites_sidecar_1.sprites.monofont60,
    Z: sprites_sidecar_1.sprites.monofont61,
    a: sprites_sidecar_1.sprites.monofont10,
    b: sprites_sidecar_1.sprites.monofont11,
    c: sprites_sidecar_1.sprites.monofont12,
    d: sprites_sidecar_1.sprites.monofont13,
    e: sprites_sidecar_1.sprites.monofont14,
    f: sprites_sidecar_1.sprites.monofont15,
    g: sprites_sidecar_1.sprites.monofont16,
    h: sprites_sidecar_1.sprites.monofont17,
    i: sprites_sidecar_1.sprites.monofont30,
    j: sprites_sidecar_1.sprites.monofont31,
    k: sprites_sidecar_1.sprites.monofont32,
    l: sprites_sidecar_1.sprites.monofont33,
    m: sprites_sidecar_1.sprites.monofont34,
    n: sprites_sidecar_1.sprites.monofont35,
    o: sprites_sidecar_1.sprites.monofont36,
    p: sprites_sidecar_1.sprites.monofont37,
    q: sprites_sidecar_1.sprites.monofont50,
    r: sprites_sidecar_1.sprites.monofont51,
    s: sprites_sidecar_1.sprites.monofont52,
    t: sprites_sidecar_1.sprites.monofont53,
    u: sprites_sidecar_1.sprites.monofont54,
    v: sprites_sidecar_1.sprites.monofont55,
    w: sprites_sidecar_1.sprites.monofont56,
    x: sprites_sidecar_1.sprites.monofont57,
    y: sprites_sidecar_1.sprites.monofont70,
    z: sprites_sidecar_1.sprites.monofont71,
    '.': sprites_sidecar_1.sprites.monofont62,
    '!': sprites_sidecar_1.sprites.monofont63,
    '?': sprites_sidecar_1.sprites.monofont64,
    ',': sprites_sidecar_1.sprites.monofont65,
    '"': sprites_sidecar_1.sprites.monofont66,
    ':': sprites_sidecar_1.sprites.monofont67,
    ' ': sprites_sidecar_1.sprites.monofont77,
    '#': sprites_sidecar_1.sprites.monofont74,
    '1': sprites_sidecar_1.sprites.monofontNumbers00,
    '2': sprites_sidecar_1.sprites.monofontNumbers01,
    '3': sprites_sidecar_1.sprites.monofontNumbers02,
    '4': sprites_sidecar_1.sprites.monofontNumbers03,
    '5': sprites_sidecar_1.sprites.monofontNumbers10,
    '6': sprites_sidecar_1.sprites.monofontNumbers11,
    '7': sprites_sidecar_1.sprites.monofontNumbers12,
    '8': sprites_sidecar_1.sprites.monofontNumbers13,
    '9': sprites_sidecar_1.sprites.monofontNumbers20,
    '0': sprites_sidecar_1.sprites.monofontNumbers21,
    $: sprites_sidecar_1.sprites.monofontNumbers22,
    '/': sprites_sidecar_1.sprites.monofontNumbers23,
    '>': sprites_sidecar_1.sprites.monofontNumbers30,
    '-': sprites_sidecar_1.sprites.monofontNumbers31,
    '+': sprites_sidecar_1.sprites.monofontNumbers32,
    '*': sprites_sidecar_1.sprites.monofontNumbers33,
    back: sprites_sidecar_1.sprites.monofont72,
    back2: sprites_sidecar_1.sprites.monofont73,
};
exports.rainbowScale = chroma_js_1.default
    .scale(['red', 'orange', 'yellow', 'green', 'blue', 'purple'])
    .colors(32)
    .map(function (c) { return (0, chroma_js_1.default)(c).num(); });
exports.rainbowScalePalette = [
    rogueDef_sidecar_1.rogueDef.colors.red,
    rogueDef_sidecar_1.rogueDef.colors.orange,
    rogueDef_sidecar_1.rogueDef.colors.yellow,
    rogueDef_sidecar_1.rogueDef.colors.green,
    rogueDef_sidecar_1.rogueDef.colors.lightBlue,
    rogueDef_sidecar_1.rogueDef.colors.darkBlue,
    rogueDef_sidecar_1.rogueDef.colors.light,
    rogueDef_sidecar_1.rogueDef.colors.peach,
    rogueDef_sidecar_1.rogueDef.colors.brown,
    rogueDef_sidecar_1.rogueDef.colors.gray,
    rogueDef_sidecar_1.rogueDef.colors.blueGray,
];
exports.riftScale = [
    rogueDef_sidecar_1.rogueDef.colors.red,
    rogueDef_sidecar_1.rogueDef.colors.orange,
    rogueDef_sidecar_1.rogueDef.colors.yellow,
    // rogueDef.colors.green,
    rogueDef_sidecar_1.rogueDef.colors.lightBlue,
    rogueDef_sidecar_1.rogueDef.colors.darkBlue,
    rogueDef_sidecar_1.rogueDef.colors.light,
    rogueDef_sidecar_1.rogueDef.colors.peach,
    rogueDef_sidecar_1.rogueDef.colors.brown,
    rogueDef_sidecar_1.rogueDef.colors.gray,
    rogueDef_sidecar_1.rogueDef.colors.blueGray,
];
// export const healthScale = chroma
//   .scale(['red', 'orange', 'yellow', 'green'])
//   .colors(10)
//   .map((c) => chroma(c).num())
exports.healthScale = [
    rogueDef_sidecar_1.rogueDef.colors.red,
    rogueDef_sidecar_1.rogueDef.colors.red,
    rogueDef_sidecar_1.rogueDef.colors.orange,
    rogueDef_sidecar_1.rogueDef.colors.orange,
    rogueDef_sidecar_1.rogueDef.colors.yellow,
    rogueDef_sidecar_1.rogueDef.colors.yellow,
    rogueDef_sidecar_1.rogueDef.colors.green,
    rogueDef_sidecar_1.rogueDef.colors.green,
    rogueDef_sidecar_1.rogueDef.colors.green,
    rogueDef_sidecar_1.rogueDef.colors.green,
];
exports.fireScale = chroma_js_1.default
    .scale([
    (0, chroma_js_1.default)(rogueDef_sidecar_1.rogueDef.colors.red),
    (0, chroma_js_1.default)(rogueDef_sidecar_1.rogueDef.colors.yellow),
    (0, chroma_js_1.default)(rogueDef_sidecar_1.rogueDef.colors.orange),
])
    .colors(32)
    .map(function (c) { return (0, chroma_js_1.default)(c).num(); });
exports.waterScale = chroma_js_1.default
    .scale([
    (0, chroma_js_1.default)(rogueDef_sidecar_1.rogueDef.colors.darkBlue),
    (0, chroma_js_1.default)(rogueDef_sidecar_1.rogueDef.colors.lightBlue),
    (0, chroma_js_1.default)(rogueDef_sidecar_1.rogueDef.colors.light),
])
    .colors(32)
    .map(function (c) { return (0, chroma_js_1.default)(c).num(); });
var spriteBack = sprites_sidecar_1.sprites.monofont72;
// export interface IMonofontGlyph {
//   x: number
//   y: number
//   char: string
//   frames: ISPD[]
//   image: PImage
//   visible: boolean
// }
// const objs: IMonofontGlyph[] = []
var _idx = 0;
// const objsVisible: IMonofontGlyph[] = []
// export const create = () => {
//   if (_idx < objs.length) {
//     return objs[_idx++]
//   }
//   let image = spritesUtil.createImage(
//     rogueLayers.getLayers().ui1,
//     sprites.monofont64[0],
//   )
//   image.scale = rogueDef.scale
//   const c: IMonofontGlyph = {
//     x: 0,
//     y: 0,
//     char: '?',
//     frames: sprites.monofont64,
//     image,
//     visible: true,
//   }
//   _idx++
//   objs.push(c)
//   return c
// }
// export const setPos = (c: IRogueGlyph, x: number, y: number) => {
//   c.x = x
//   c.y = y
// }
var getSprite = function (c) {
    return fontMap[c] || fontMap._default;
};
exports.getSprite = getSprite;
var drawBackground = function (x, y, colorBack, liveFor) {
    if (liveFor === void 0) { liveFor = 0; }
    if (colorBack !== rogueDef_sidecar_1.rogueDef.colors.none) {
        rogueGlyphs_sidecar_1.rogueGlyphs.writeBg(x, y, colorBack, spriteBack, liveFor);
        // let cBack = rogueGlyphs.create()
        // rogueGlyphs.setPos(cBack, x, y)
        // cBack.char = 'back'
        // spritesUtil.setPackedFrameSameScale(cBack.image, spriteBack[0])
        // cBack.image.tint = colorBack
        // cBack.visible = true
    }
};
exports.drawBackground = drawBackground;
var write = function (x, y, text, color, colorBack, onClick, onHover, hotkey, effect, liveFor) {
    if (color === void 0) { color = rogueDef_sidecar_1.rogueDef.colors.light; }
    if (colorBack === void 0) { colorBack = rogueDef_sidecar_1.rogueDef.colors.none; }
    if (onClick === void 0) { onClick = null; }
    if (onHover === void 0) { onHover = null; }
    if (hotkey === void 0) { hotkey = null; }
    if (effect === void 0) { effect = ''; }
    if (liveFor === void 0) { liveFor = 0; }
    var isWave = effect === 'wave';
    var isRainbow = effect === 'rainbow';
    var isFire = effect === 'fire';
    var isWater = effect === 'water';
    if (effect === 'rainbowwave') {
        isWave = true;
        isRainbow = true;
    }
    var elapsed = common_sidecar_1.common.getElapsedTime();
    if (colorBack !== rogueDef_sidecar_1.rogueDef.colors.none) {
        if (rogueMouseAreas_sidecar_1.rogueMouseAreas.isOver(x, y, text.length, 1)) {
            colorBack = rogueDef_sidecar_1.rogueDef.colors.lightBlue;
        }
    }
    for (var i = 0; i < text.length; i++) {
        if (colorBack !== rogueDef_sidecar_1.rogueDef.colors.none) {
            (0, exports.drawBackground)(x + i, y, colorBack, liveFor);
        }
        var c = rogueGlyphs_sidecar_1.rogueGlyphs.create();
        var yo = 0;
        if (isWave) {
            yo = Math.sin(elapsed * 4 + 0.5 * (x + i + y)) * 0.2;
        }
        if (isRainbow) {
            color =
                exports.rainbowScale[(0, mathUtils_1.betterMod)(x + i + y - Math.floor(elapsed / 0.1), exports.rainbowScale.length)];
        }
        if (isFire) {
            color =
                exports.fireScale[(0, mathUtils_1.betterMod)(x + i + y - Math.floor(elapsed / 0.1), exports.fireScale.length)];
        }
        if (isWater) {
            color =
                exports.waterScale[(0, mathUtils_1.betterMod)(x + i + y - Math.floor(elapsed / 0.1), exports.waterScale.length)];
        }
        rogueGlyphs_sidecar_1.rogueGlyphs.write(x + i, y + yo, text[i], color, liveFor);
        // rogueGlyphs.setPos(c, x + i, y + yo)
        // c.char = text[i]
        // // Update sprite
        // spritesUtil.setPackedFrameSameScale(c.image, getSprite(c.char)[0])
        // c.image.tint = color
        // c.visible = true
    }
    if (onClick) {
        // const onHover = () => {
        //   console.log('hover', text)
        //   write(x + 1, y, text, color, rogueDef.colors.lightBlue)
        // }
        rogueMouseAreas_sidecar_1.rogueMouseAreas.create(x, y, text.length, 1, onHover, onClick);
        if (hotkey) {
            rogueHotkeys_sidecar_1.rogueHotkeys.create(hotkey, onClick);
        }
    }
    return text.length;
};
exports.write = write;
var measureWrapped = function (width, text) {
    return (0, exports.writeWrapped)(0, 0, width, text, rogueDef_sidecar_1.rogueDef.colors.none, rogueDef_sidecar_1.rogueDef.colors.none, 9999, true);
};
exports.measureWrapped = measureWrapped;
var writeWrapped = function (x, y, width, text, color, colorBack, elapsed, measureOnly) {
    if (color === void 0) { color = rogueDef_sidecar_1.rogueDef.colors.light; }
    if (colorBack === void 0) { colorBack = rogueDef_sidecar_1.rogueDef.colors.none; }
    if (elapsed === void 0) { elapsed = 9999; }
    if (measureOnly === void 0) { measureOnly = false; }
    var colorStack = [];
    var effect = '';
    var xs = x;
    var xe = x + width - 1;
    var ys = y;
    // get chunks
    var chunks = [];
    var chunk = '';
    var addChunk = function () {
        var len = chunk.length;
        if (chunk) {
            chunks.push({
                text: chunk,
                x: x,
                color: color,
                y: y,
                effect: effect,
            });
            chunk = '';
        }
        return len;
    };
    var isInCommandReadMode = false;
    var changedColor = false;
    var command = '';
    for (var i = 0; i < text.length; i++) {
        var c = text[i];
        if (isInCommandReadMode) {
            if (c === '|') {
                isInCommandReadMode = false;
                if (command.startsWith('color:')) {
                    var colorText = command.substring('color:'.length);
                    var num = parseInt(colorText);
                    colorStack.push(color);
                    changedColor = true;
                    color = num;
                }
                else if (command === 'red') {
                    colorStack.push(color);
                    changedColor = true;
                    color = rogueDef_sidecar_1.rogueDef.colors.red;
                }
                else if (command === 'yellow') {
                    colorStack.push(color);
                    changedColor = true;
                    color = rogueDef_sidecar_1.rogueDef.colors.yellow;
                }
                else if (command === 'orange') {
                    colorStack.push(color);
                    changedColor = true;
                    color = rogueDef_sidecar_1.rogueDef.colors.orange;
                }
                else if (command === 'green') {
                    colorStack.push(color);
                    changedColor = true;
                    color = rogueDef_sidecar_1.rogueDef.colors.green;
                }
                else if (command === 'lightBlue') {
                    colorStack.push(color);
                    changedColor = true;
                    color = rogueDef_sidecar_1.rogueDef.colors.lightBlue;
                }
                else if (command === 'black') {
                    colorStack.push(color);
                    changedColor = true;
                    color = rogueDef_sidecar_1.rogueDef.colors.pureBlack;
                }
                else if (command === 'dark') {
                    colorStack.push(color);
                    changedColor = true;
                    color = rogueDef_sidecar_1.rogueDef.colors.dark;
                }
                else if (command === 'wave') {
                    effect = 'wave';
                }
                else if (command === 'water') {
                    effect = 'water';
                }
                else if (command === 'rainbow') {
                    effect = 'rainbow';
                }
                else if (command === 'fire') {
                    effect = 'fire';
                }
                else if (command === 'rainbowwave') {
                    effect = 'rainbowwave';
                }
                else {
                    console.warn('Unknown text formatting command', command);
                }
                continue;
            }
            if (c === ']') {
                isInCommandReadMode = false; // end early?
                continue;
            }
            else {
                command += c;
                continue;
            }
        }
        if (c === '[') {
            // Start reading command
            x += addChunk();
            isInCommandReadMode = true;
            command = '';
            continue;
        }
        if (c === ']') {
            // Pop color / effect and end chunk
            x += addChunk();
            if (changedColor) {
                color = colorStack.pop() || rogueDef_sidecar_1.rogueDef.colors.light;
                changedColor = false;
            }
            effect = '';
            continue;
        }
        if (c === ' ' || c === '\n' || c === '\r') {
            x += addChunk() + 1;
            if (c === '\n') {
                y++;
                x = xs;
            }
        }
        else {
            chunk += c;
        }
        // Newline detection
        if (x + chunk.length > xe + 1) {
            if (x === xs) {
                addChunk();
            }
            x = xs;
            y++;
        }
    }
    addChunk();
    var ye = y;
    var maxBack = elapsed / 0.002;
    var idxBack = 0;
    if (colorBack !== rogueDef_sidecar_1.rogueDef.colors.none) {
        for (var j = ys; j <= ye; j++) {
            for (var i = xs; i <= xe; i++) {
                idxBack++;
                if (idxBack > maxBack) {
                    break;
                }
                (0, exports.drawBackground)(i, j, colorBack);
            }
            if (idxBack > maxBack) {
                break;
            }
        }
    }
    var maxChars = elapsed / 0.02; //0.0125
    var idxChars = 0;
    if (!measureOnly) {
        chunks.forEach(function (c) {
            if (idxChars > maxChars) {
                return false;
            }
            idxChars += c.text.length;
            if (idxChars > maxChars) {
                var remaining = maxChars - idxChars + c.text.length;
                var remainingText = c.text.substring(0, remaining);
                if (remainingText) {
                    (0, exports.write)(c.x, c.y, remainingText, c.color, rogueDef_sidecar_1.rogueDef.colors.none, null, null, null, c.effect);
                }
                return false;
            }
            else {
                (0, exports.write)(c.x, c.y, c.text, c.color, rogueDef_sidecar_1.rogueDef.colors.none, null, null, null, c.effect);
            }
        });
    }
    var w = xe - xs + 1;
    var h = ye - ys + 1 + 1;
    return { w: w, h: h };
};
exports.writeWrapped = writeWrapped;
// export const drawAll = () => {
//   objs.forEach((c) => {
//     c.image.x = c.x * rogueDef.sizeX
//     c.image.y = c.y * rogueDef.sizeY
//     c.image.visible = c.visible
//     c.visible = false // reset
//   })
//   _idx = 0
// }
